import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-grid tw-grid-cols-12 tw-gap-4" };
const _hoisted_2 = {
    key: 0,
    class: "mt-4 tw-space-y-6"
};
const _hoisted_3 = { class: "tw-space-y-3" };
const _hoisted_4 = {
    key: 0,
    class: "tw-w-full"
};
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "single-slide" };
const _hoisted_7 = { class: "box tw-mb-4" };
const _hoisted_8 = { class: "img-box" };
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
    key: 1,
    class: "tw-w-full tw-my-5"
};
const _hoisted_11 = { class: "tw-flex tw-gap-3" };
const _hoisted_12 = {
    key: 0,
    class: "tw-relative tw-w-[70%] tw-h-[calc(100vh-180px)] tw-mt-6 tw-hidden md:tw-block"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "tw-relative tw-w-[95%] tw-h-[60vh] tw-mx-auto" };
const _hoisted_15 = ["src"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = { class: "tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-60 tw-opacity-0 hover:tw-opacity-100 tw-transition-opacity tw-duration-300 tw-flex tw-items-center tw-justify-center tw-flex-col tw-rounded-xl" };
const _hoisted_19 = { class: "tw-text-white tw-text-sm tw-font-bold tw-text-center" };
const _hoisted_20 = { class: "tw-text-white tw-text-[12px]" };
const _hoisted_21 = {
    key: 0,
    class: "md:tw-block tw-hidden tw-col-span-3"
};
import { ref, onMounted, onUnmounted, watch, } from 'vue';
import { useRouter } from 'vue-router';
import { useLogo } from '@/hooks/useLogo';
import { useSidebar } from '@/stores/sidebar';
import { usePopupStore } from '@/stores/popup';
import GamesByProviders from './GamesByProviders.vue';
import SideBarProviders from '@/components/Casino/SideBarProviders.vue';
// Props
export default /*@__PURE__*/ _defineComponent({
    __name: 'CasinoComponentForAll',
    props: {
        games: {},
        casinoSideBarCategories: {},
        gameCategories: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ['viewGames'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const scrollContainer = ref(null);
        const gameUrl = ref(null);
        const router = useRouter();
        const logo = useLogo();
        const { handleCloseSidebar } = useSidebar();
        const activeAccordion = ref(null);
        // Search query ref
        const searchQuery = ref('');
        // Function to check if a category or game is selected
        const isSelected = (href) => router.currentRoute.value.path === href;
        const filteredGames = (gameCat) => {
            return props.games.filter(game => game.gamebank === gameCat.gameType &&
                game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        };
        const showProviders = ref(false);
        const toggleProviders = () => {
            showProviders.value = !showProviders.value;
        };
        const activeCategoryId = ref(null);
        const handleGameClick = async (game) => {
            const mobile = window.innerWidth <= 768;
            const user = localStorage.getItem('user');
            if (!user) {
                const popupStore = usePopupStore();
                popupStore.showPopup('login');
                return;
            }
            const gameUrlFormat = `https://arabianbet.net/game/${game.name}/?api_exit=/`;
            // if (mobile) {
            //   window.open(gameUrlFormat, '_blank')
            //   closeGame()
            // } else {
            gameUrl.value = gameUrlFormat;
            // }
        };
        const closeGame = () => (gameUrl.value = null);
        const toggleView = (categoryId) => {
            emit('viewGames', { title: 'All', id: null });
            router.replace({ path: '/casino/all' });
            activeCategoryId.value =
                activeCategoryId.value === categoryId ? null : categoryId;
        };
        const handleViewMore = () => {
            // Emit the event to the parent (CasinoComponent)
            emit('viewGames'); // Pass any required data
        };
        const config = ref({
            itemsToShow: 16,
            autoplay: 3000,
            infinite: true,
            gap: 10,
        });
        const screenWidth = ref(window.innerWidth);
        watch(screenWidth, newWidth => {
            if (newWidth < 640) {
                config.value.itemsToShow = 3;
            }
            else {
                config.value.itemsToShow = 6;
            }
        });
        watch(scrollContainer, newValue => {
            newValue = newValue[0];
            if (newValue) {
                newValue?.addEventListener('scroll', () => {
                    if (newValue.scrollTop + newValue.clientHeight >= newValue.scrollHeight &&
                        !props?.isLoading) {
                        console.log('here we are doing something');
                        emit('viewGames');
                    }
                });
            }
        });
        onMounted(() => {
            const handleResize = () => {
                screenWidth.value = window.innerWidth;
            };
            window.addEventListener('resize', handleResize);
            onUnmounted(() => {
                window.removeEventListener('resize', handleResize);
            });
        });
        return (_ctx, _cache) => {
            const _component_Card = _resolveComponent("Card");
            const _component_CardContent = _resolveComponent("CardContent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass([gameUrl.value ? 'tw-col-span-12' : 'md:tw-col-span-9 tw-col-span-12', ""])
                }, [
                    (_ctx.selectedCategory && _ctx.selectedCategory.title === 'All')
                        ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.casinoSideBarCategories, (gameCat) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: gameCat.id,
                                            class: "tw-border-none tw-p-0"
                                        }, [
                                            (!activeCategoryId.value || activeCategoryId.value === gameCat.id)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tw-w-full tw-p-0 tw-mb-0" }, [
                                                        _createElementVNode("div", { class: "tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-text-[#738499] tw-group tw-border-l-transparent" })
                                                    ], -1)),
                                                    (activeCategoryId.value === gameCat.id)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                            _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                                default: _withCtx(() => [
                                                                    (filteredGames(gameCat).length)
                                                                        ? (_openBlock(), _createElementBlock("div", {
                                                                            key: 0,
                                                                            ref_for: true,
                                                                            ref_key: "scrollContainer",
                                                                            ref: scrollContainer
                                                                        }, [
                                                                            _createElementVNode("div", _hoisted_5, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat).slice(0, 20), (game) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: game.id,
                                                                                        class: "col-25"
                                                                                    }, [
                                                                                        _createElementVNode("div", _hoisted_6, [
                                                                                            _createElementVNode("div", _hoisted_7, [
                                                                                                _createElementVNode("div", _hoisted_8, [
                                                                                                    _createElementVNode("img", {
                                                                                                        src: `https://arabianbet.net/frontend/Default/ico/${game.name}.jpg`,
                                                                                                        alt: game.name,
                                                                                                        class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                    }, null, 8, _hoisted_9)
                                                                                                ])
                                                                                            ])
                                                                                        ])
                                                                                    ]));
                                                                                }), 128))
                                                                            ])
                                                                        ], 512))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass([gameUrl.value ? 'min-[992px]:tw-w-[70%] tw-w-full' : '', "tw-block input-categories"])
                                                            }, _cache[0] || (_cache[0] = [
                                                                _createElementVNode("div", { class: "tw-flex md:tw-hidden tw-items-center sm:tw-gap-3 tw-gap-2" }, null, -1)
                                                            ]), 2),
                                                            _createElementVNode("div", _hoisted_11, [
                                                                (gameUrl.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                                        _createElementVNode("button", {
                                                                            class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                                                            onClick: closeGame
                                                                        }, " Close "),
                                                                        _createElementVNode("iframe", {
                                                                            src: gameUrl.value,
                                                                            frameborder: "0",
                                                                            class: "tw-w-full tw-h-full"
                                                                        }, null, 8, _hoisted_13)
                                                                    ]))
                                                                    : _createCommentVNode("", true),
                                                                (gameUrl.value)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 1,
                                                                        class: "tw-fixed tw-mt-18 tw-inset-0 tw-bg-black tw-bg-opacity-75 tw-z-50 tw-flex tw-items-center tw-justify-center md:tw-hidden",
                                                                        onClick: _withModifiers(closeGame, ["self"])
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_14, [
                                                                            _createElementVNode("button", {
                                                                                class: "tw-absolute tw-top-8 tw-right-0 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                                                                                onClick: closeGame
                                                                            }, " Close "),
                                                                            _createElementVNode("iframe", {
                                                                                src: gameUrl.value,
                                                                                frameborder: "0",
                                                                                class: "tw-w-full tw-h-full tw-rounded-lg"
                                                                            }, null, 8, _hoisted_15)
                                                                        ])
                                                                    ]))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("div", {
                                                                    class: _normalizeClass(gameUrl.value ? 'md:tw-w-[30%] tw-w-full' : 'tw-w-full')
                                                                }, [
                                                                    _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                                                                        default: _withCtx(() => [
                                                                            (_ctx.games.length)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 0,
                                                                                    ref_for: true,
                                                                                    ref_key: "scrollContainer",
                                                                                    ref: scrollContainer,
                                                                                    class: _normalizeClass([
                                                                                        gameUrl.value
                                                                                            ? 'tw-max-h-[calc(100vh-214px)]'
                                                                                            : 'tw-max-h-[calc(100vh-180px)]',
                                                                                        "tw-overflow-auto"
                                                                                    ])
                                                                                }, [
                                                                                    _createVNode(_component_CardContent, {
                                                                                        class: _normalizeClass(gameUrl.value
                                                                                            ? 'scroller tw-grid tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-4'
                                                                                            : 'scroller tw-grid tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4')
                                                                                    }, {
                                                                                        default: _withCtx(() => [
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                                    key: game.id
                                                                                                }, [
                                                                                                    _createElementVNode("div", {
                                                                                                        class: "tw-flex tw-relative tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                                                                        onClick: ($event) => (handleGameClick(game))
                                                                                                    }, [
                                                                                                        _createElementVNode("img", {
                                                                                                            src: `https://arabianbet.net/frontend/Default/ico/${game.name}.jpg`,
                                                                                                            alt: game.name,
                                                                                                            class: "tw-object-cover tw-rounded-xl tw-w-full tw-h-full"
                                                                                                        }, null, 8, _hoisted_17),
                                                                                                        _createElementVNode("div", _hoisted_18, [
                                                                                                            _cache[1] || (_cache[1] = _createElementVNode("button", { class: "play-btn-game tw-mb-2 tw-mt-10" }, " Play ", -1)),
                                                                                                            _createElementVNode("h2", _hoisted_19, _toDisplayString(game.title), 1),
                                                                                                            _createElementVNode("p", _hoisted_20, _toDisplayString(game.category_temp), 1)
                                                                                                        ])
                                                                                                    ], 8, _hoisted_16)
                                                                                                ]));
                                                                                            }), 128))
                                                                                        ]),
                                                                                        _: 1
                                                                                    }, 8, ["class"]),
                                                                                    (_ctx.isLoading)
                                                                                        ? (_openBlock(), _createBlock(_component_CardContent, {
                                                                                            key: 0,
                                                                                            class: _normalizeClass(gameUrl.value
                                                                                                ? 'tw-mt-6 tw-grid tw-grid-cols-3 sm:tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4'
                                                                                                : 'tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6')
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                                                                    return _createElementVNode("div", {
                                                                                                        key: 'skeleton-' + index,
                                                                                                        class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                                                                    }, _cache[2] || (_cache[2] = [
                                                                                                        _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                                                                    ]));
                                                                                                }), 64))
                                                                                            ]),
                                                                                            _: 1
                                                                                        }, 8, ["class"]))
                                                                                        : _createCommentVNode("", true)
                                                                                ], 2))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ], 2)
                                                            ])
                                                        ]))
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createBlock(GamesByProviders, {
                            key: 1,
                            games: _ctx.games,
                            selectedCategory: _ctx.selectedCategory,
                            isLoading: _ctx.isLoading
                        }, null, 8, ["games", "selectedCategory", "isLoading"]))
                ], 2),
                (!gameUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(SideBarProviders, {
                            games: _ctx.games,
                            selectedCategory: _ctx.selectedCategory,
                            isLoading: _ctx.isLoading
                        }, null, 8, ["games", "selectedCategory", "isLoading"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
